import { UserCreate } from 'components/user/user-create/UserCreate'
import { useState } from 'react'
import { useValidation } from 'hooks/useValidation'
import { constructOptionsSelect, convertErrorMessage, generatePasswordAlphanumeric, uploadFileToS3 } from 'utils/utils'
import { useFetch } from 'services/useFetch'
import { API_USER } from 'services/apiUser'
import { useNavigate } from 'react-router-dom'
import { CREATE_PROFILE_VALIDATION } from 'services/validation/userValidation'
import { Alert } from 'avo-ui'

const INIT_USER = {
    profile_picture: null,
    name: null,
    email: null,
    birth_date: null,
    phone_number: null,
    gender: null,
    role: null,
    password: null,
}

const FIELD_NAME_DETAIL = {
    profile_picture: 'Foto Profile',
    name: 'Nama',
    email: 'Email',
    birth_date: 'Tanggal lahir',
    phone_number: 'Nomor handphone',
    gender: 'Jenis kelamin',
    role: 'Role',
    password: 'Password',
}

export const UserCreateContainer = () => {
    const navigate = useNavigate()
    const [dataUser, setDataUser] = useState(INIT_USER)
    const { validateForm, errorForm } = useValidation({
        form: dataUser,
        schema: CREATE_PROFILE_VALIDATION,
    })
    const [errorMessage, setErrorMessage] = useState(errorForm)
    const { fetching: createUserApi, isLoading: isCreating } = useFetch(API_USER.CREATE)
    const { fetching: getUrlImagesAPi } = useFetch(API_USER.URL_UPLOAD_IMAGES)
    const { data: roleList } = useFetch(API_USER.ROLE_LIST, {}, { isFetching: true })

    const setUploadUserImage = async () => {
        try {
            const s3Urls = await getUrlImagesAPi({ filename: dataUser?.profile_picture?.name?.replace(/\s/g, '') })
            await uploadFileToS3(s3Urls?.data, dataUser?.profile_picture?.file)
            await onSave(`${s3Urls.data.url}${s3Urls.data.fields.key}`)
        } catch (err) {
            console.log('upload failed')
        }
    }

    const onChangeForm = (e) => {
        const { name, value } = e
        setDataUser({ ...dataUser, [name]: value })
    }

    const onGenerate = () => {
        setDataUser({ ...dataUser, password: generatePasswordAlphanumeric() })
    }

    const onSubmit = () => {
        setErrorMessage({})
        validateForm().then(() => {
            if (!!dataUser?.profile_picture?.name) {
                setUploadUserImage()
            } else {
                onSave()
            }
        })
    }

    const onSave = async (url) => {
        let payload = {
            ...dataUser,
            profile_picture: !!url ? url : null,
            role_id: dataUser?.role.value,
            phone_number: dataUser?.phone_number ? `62${dataUser?.phone_number}` : null,
        }
        try {
            await createUserApi(payload)
            navigate('/user/user-list')
            return Alert({
                icon: 'success',
                title: 'Success',
                message: 'User Created !',
            })
        } catch (error) {
            setErrorMessage(convertErrorMessage(error?.data, FIELD_NAME_DETAIL))
        }
    }

    const props = {
        dataUser,
        onChangeForm,
        onGenerate,
        errorForm: { ...errorForm, ...errorMessage },
        isLoading: isCreating,
        onSubmit,
        roleList: roleList?.data ? constructOptionsSelect(roleList?.data, 'name', 'id') : [],
    }

    return <UserCreate {...props} />
}
